// extracted by mini-css-extract-plugin
module.exports = {"dislike-button":"dislike-button--3O8G1Jd5"};